type Device = {
    id: number;
    name: string;
    code: string;
    type: DeviceTypeEnum;
    device_type: 'HARDWARE' | 'SOFTWARE';
    current_status: DeviceCurrentStatusEnum;
    current_status_texts: string[];
    current_communication_status: boolean;
};

export interface DevicesStatus {
    total: number;
    warnings: number;
    errors: number;
}

enum DeviceCurrentStatusEnum {
    RUNNING = 'default',
    STOPPED = 'disabled',
    FAULT = 'error',
    WARNING = 'warn',
}

enum DeviceTypeEnum {
    DISPLAY_5D,
    DISPLAY_5D_M_BIG,
    DISPLAY_5D_M_SMALL,
    DISPLAY_5D_RGB_BIG,
    DISPLAY_B,
    DISPLAY_B_N,
    DISPLAY_COUNTER,
    DISPLAY_S_N,
    DISPLAY_SP123F,
    ENTRY_POINT,
    ENTRY_POINT_FITNESS,
    ENTRY_POINT_LPR,
    ENTRY_POINT_SP201,
    EXIT_POINT,
    EXIT_POINT_FITNESS,
    EXIT_POINT_LPR,
    EXIT_POINT_SP201,
    KEYBOARD,
    LOCAL_WORK_STATION,
    LPR_RUNNING_SERVICE,
    PAY_MASHINE,
    PAY_MASHINE_ND,
    PAY_MASHINE_VLD,
    RUNNING_SERVICE,
    VALIDATION_POINT,
    VALIDATION_SOFT,
}

export { type Device, DeviceCurrentStatusEnum, DeviceTypeEnum };
